module.exports = __webpack_public_path__ + "static/media/ic_controlroom.6c4b7ee1.png";